import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';
import { message } from 'antd';
// Токены теперь в httpOnly cookies, они отправляются автоматически

/**
 * Динамическое определение API URL на основе текущего домена
 */
const getApiBaseUrl = (): string => {
  // Если мы в браузере, определяем по текущему домену
  if (typeof window !== 'undefined' && window.location) {
    const hostname = window.location.hostname;
    
    // Явная проверка на localhost варианты
    const isLocalhost = hostname === 'localhost' || 
                       hostname === '127.0.0.1' || 
                       hostname === '::1' ||
                       hostname === '0.0.0.0' ||
                       hostname.startsWith('192.168.') ||
                       hostname.startsWith('10.') ||
                       hostname.startsWith('172.');
    
    if (isLocalhost) {
      const url = 'http://localhost:3001/api';
      return url;
    }
    
    // Для всех остальных случаев - используем относительный путь
    const url = '/api';
    return url;
  }
  
  // Fallback для SSR/тестов
  const envUrl = import.meta.env.VITE_API_URL;
  if (envUrl && envUrl.startsWith('/')) {
    return envUrl;
  }
  
  const isDev = import.meta.env.DEV === true || import.meta.env.MODE === 'development';
  return isDev ? 'http://localhost:3001/api' : '/api';
};

export const api = axios.create({
  // Не устанавливаем baseURL здесь - будем устанавливать в interceptor
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-CSRF-Token'
});

api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // ВСЕГДА устанавливаем baseURL динамически при каждом запросе
    const dynamicBaseUrl = getApiBaseUrl();
    config.baseURL = dynamicBaseUrl;
    
    // Токены теперь в httpOnly cookies, они отправляются автоматически
    // Не нужно устанавливать Authorization header вручную
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    const originalRequest = error.config;
    
    if (!originalRequest) {
      message.error('Ошибка запроса к серверу');
      return Promise.reject(error);
    }

    // Если ошибка 401, редиректим на страницу входа
    // Токены в httpOnly cookies, обновление токена обрабатывается сервером
    if (error.response?.status === 401 && !originalRequest.url?.includes('auth/refresh')) {
      message.error('Сессия истекла. Пожалуйста, войдите снова');
      window.location.href = '/login';
      return Promise.reject(error);
    }

    // Если нет соединения с сервером
    if (!error.response) {
      message.error('Ошибка сети. Проверьте подключение к интернету');
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);